module.exports = __webpack_public_path__ + "img/faro-resort-3.561e945d.jpg";